/**
 * index.jsx — Application entry point
 * ────────────────────────────────────
 * Change log:
 *   2026-03-04  Added BillingProvider inside AuthProvider.
 *               BillingProvider depends on AuthContext (needs teamId),
 *               so it must be nested inside AuthProvider.
 */
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { BillingProvider } from "./contexts/BillingContext";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AuthProvider>
    <BillingProvider>
      <App />
    </BillingProvider>
  </AuthProvider>
);
